
<template>
    <GhostBtn class="CurrencySelectorBtn" @click="$emit('click')">
        {{ currency }} <i class="lnr-network Icon"></i>
    </GhostBtn>
</template>
<script lang="ts" setup>
import GhostBtn from '@components/GhostBtn/GhostBtn.vue';

const props = defineProps({
    currency: {
        type: String,
        default: 'EUR'
    }
})
</script>

<style scoped lang="scss">
    .CurrencySelectorBtn {
        color: $Blue-700;
        @include TextStyle(UiMediumSemibold);
        .Icon {
            font-size: 1rem;
        }
    }
</style>